import React, { useContext, useEffect, useState } from 'react';
import client from '../../../../api/client';
import CustomInput from '../../../../components/CustomInputs/CustomInput';
import CustomSelectInput from '../../../../components/CustomSelectInput/CustomSelectInput';
import StatusView from '../../../../components/StatusView/StatusView';
import { Dropdown } from 'flowbite-react';
import moment from 'moment';
import { FaEllipsisH } from 'react-icons/fa';
import { UsersData } from '../../../../types/TablesTypes/Users';
import icon from '../../../../assets/shareholdersIcon.png';
import { UserContext } from '../../../../contexts/UserContext';
import showToast from '../../../../components/CustomToast/toastHelper';

interface CreateUsersProps {
    close: () => void;
    getUsers:()=>void;
}

const CreateUsers = ({ close, getUsers }: CreateUsersProps) => {
    const {userDetails} = useContext(UserContext) ?? {}
    const {activeSubsidiary, user} = userDetails
    
    const [inputs, setInputs] = useState({
        firstName: "",
        lastName: "",
        email: "",
        mobileNumber: "",
        role: ""
    });

    const [roles, setRoles] = useState<any[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            await fetchRoles();
        };
        fetchData();
    }, []);

    const fetchRoles = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/role/users');
            const rolesData = response.data.data;
            setRoles(rolesData);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setInputs({
            ...inputs,
            [name]: value,
        });
    };

    const createUser = async () => {
        const payload = {
            ...inputs,
            createdBy: user?.id, 
            isUpdate: false,
            subsidiaryId: activeSubsidiary?.id  
        };

        try {
            const response = await client.post('/subsidiary/dashboard/users/create', payload);
            const message = response?.data?.message;
            showToast(message,"success")
            close()
            getUsers()
        } catch (err: any) {
            
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                console.error('error getting data', err);
                const message = err?.response?.data?.message;
                showToast(message,"error")
            }
        }
    };

    return (
        <div>
            <div className='mb-6'>
                <img src={icon} className='my-3' alt="icon" />
                <div className='my-3'>
                    <p className='text-xl font-bold'>Add New User</p>
                    <p className='text-sm'>Kindly fill in the information needed</p>
                </div>
            </div>
            <div>
                <CustomInput name='firstName' label='First Name' value={inputs.firstName} onChange={handleInputChange} />
            </div>
            <div>
                <CustomInput name='lastName' label='Last Name' value={inputs.lastName} onChange={handleInputChange} />
            </div>
            <div>
                <CustomInput name='mobileNumber' label='Mobile Number' value={inputs.mobileNumber} onChange={handleInputChange} />
            </div>
            <div>
                <CustomInput name='email' label='Email' value={inputs.email} onChange={handleInputChange} />
            </div>
            <div>
                <CustomSelectInput name='role' label='Role' items={roles} displayKey='name' valueKey='name' value={inputs.role} onChange={(role)=>setInputs({...inputs,role:role})} />
            </div>
            <div className='flex gap-4 my-3'>
                <button className='w-1/4 border px-6 py-3 rounded-lg text-md font-semibold' onClick={close}>Cancel</button>
                <button className='w-3/4 border px-6 py-3 rounded-lg bg-custom-button-green text-md font-semibold hover:bg-green-900 hover:text-white' onClick={createUser}>Create New user</button>
            </div>
        </div>
    );
};

export default CreateUsers;
